import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=33b33732&scoped=true"
import script from "./guide.vue?vue&type=script&lang=js"
export * from "./guide.vue?vue&type=script&lang=js"
import style0 from "./guide.vue?vue&type=style&index=0&id=33b33732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b33732",
  null
  
)

export default component.exports